module.exports = __webpack_public_path__ + "img/team.f8faebed.png";